{
  "nameInput": {
    "placeholder": "آپ کا نام کیا ہے؟"
  },
  "signIn": {
    "tagline": "نیت سے آغاز کریں۔",
    "signingIn": "سائن اِن ہو رہا ہے…",
    "continueApple": "Apple کے ساتھ جاری رکھیں",
    "continueApple_aria": "Apple کے ساتھ جاری رکھیں",
    "continueGoogle": "Google کے ساتھ جاری رکھیں",
    "continueGoogle_aria": "Google کے ساتھ جاری رکھیں",
    "logo_alt": "Rhemn",
    "footer": "سائن اِن کرنے سے، آپ ہماری سروس کی شرائط اور <privacyLink>رازداری کی پالیسی</privacyLink> سے اتفاق کرتے ہیں۔",
    "divider": "یا"
  },
  "email": {
    "identity": {
      "label": "ای میل پتہ",
      "placeholder": "you@example.com",
      "change": "تبدیل کریں",
      "change_aria": "ای میل پتہ تبدیل کریں"
    },
    "password": {
      "label": "پاس ورڈ",
      "labelNew": "ایک پاس ورڈ منتخب کریں",
      "placeholder": "پاس ورڈ",
      "placeholderNew": "ایک پاس ورڈ بنائیں",
      "show": "پاس ورڈ دکھائیں",
      "hide": "پاس ورڈ چھپائیں"
    },
    "actions": {
      "continue": "جاری رکھیں",
      "signIn": "سائن ان",
      "createAccount": "اکاؤنٹ بنائیں",
      "forgot": "پاس ورڈ بھول گئے؟",
      "backToSignIn": "سائن ان پر واپس جائیں",
      "iVerified": "میں نے اپنا ای میل تصدیق کر لیا",
      "resend": "لنک دوبارہ بھیجیں",
      "resendIn": "{{time}} میں دوبارہ بھیجیں",
      "signInInstead": "سائن ان"
    },
    "busy": {
      "checking": "جانچا جا رہا ہے…",
      "signingIn": "سائن ان ہو رہا ہے…",
      "creating": "آپ کا اکاؤنٹ بنایا جا رہا ہے…",
      "sending": "بھیجا جا رہا ہے…"
    },
    "switch": {
      "toCreate": "Rhemn پر نئے ہیں؟ <switchBtn>اکاؤنٹ بنائیں</switchBtn>",
      "toSignIn": "پہلے سے اکاؤنٹ ہے؟ <switchBtn>سائن ان کریں</switchBtn>"
    },
    "strength": {
      "tooShort": "کم از کم 12 حروف۔",
      "level1": "اچھا۔ جتنا لمبا، اتنا مضبوط۔",
      "level2": "مضبوط پاس ورڈ۔",
      "level3": "بہت مضبوط پاس ورڈ۔"
    },
    "sent": {
      "title": "اپنا ان باکس دیکھیں",
      "body": "ہم نے {{email}} پر ری سیٹ لنک بھیجا ہے۔ یہ ایک گھنٹے میں ختم ہو جائے گا۔",
      "resent": "دوبارہ بھیج دیا۔ اپنا ان باکس دیکھیں۔"
    },
    "verify": {
      "title": "اپنے ای میل کی تصدیق کریں",
      "body": "ہم نے {{email}} پر ایک لنک بھیجا ہے۔ اپنا اکاؤنٹ مکمل کرنے کے لیے اسے کھولیں — آگے ہم خود بخود جاری رکھیں گے۔",
      "waiting": "آپ کے لنک کھولنے کا انتظار ہے…",
      "resent": "دوبارہ بھیج دیا۔ اپنا ان باکس دیکھیں۔"
    },
    "errors": {
      "invalidEmail": "یہ ای میل پتہ نہیں لگتا۔",
      "missingPassword": "اپنا پاس ورڈ درج کریں۔",
      "invalidCredential": "ای میل یا پاس ورڈ درست نہیں۔",
      "emailInUse": "اس ای میل کا پہلے سے اکاؤنٹ ہے۔ <signInBtn>سائن ان کریں۔</signInBtn>",
      "weakPassword": "کم از کم 12 حروف استعمال کریں۔",
      "passwordTooShort": "کم از کم 12 حروف استعمال کریں۔",
      "passwordCommon": "یہ پاس ورڈ اندازہ لگانا بہت آسان ہے۔ کچھ کم متوقع آزمائیں۔",
      "emailNotVerified": "جاری رکھنے سے پہلے اپنے ای میل کی تصدیق کریں۔",
      "providerGoogle": "یہ ای میل پہلے سے Google کے ساتھ سیٹ ہے۔ نیچے Google کے ساتھ جاری رکھیں۔",
      "providerApple": "یہ ای میل پہلے سے Apple کے ساتھ سیٹ ہے۔ نیچے Apple کے ساتھ جاری رکھیں۔",
      "userDisabled": "یہ اکاؤنٹ غیر فعال کر دیا گیا ہے۔",
      "requiresRecentLogin": "یہ تبدیلی کرنے کے لیے دوبارہ سائن ان کریں۔",
      "sessionExpired": "آپ کا سیشن ختم ہو گیا۔ دوبارہ سائن ان کریں۔",
      "expiredActionCode": "اس لنک کی میعاد ختم ہو گئی۔ نیا لنک طلب کریں۔",
      "invalidActionCode": "یہ لنک اب درست نہیں۔ نیا لنک طلب کریں۔",
      "tooManyRequests": "بہت زیادہ کوششیں۔ چند منٹ انتظار کریں، یا اپنا پاس ورڈ ری سیٹ کریں۔",
      "network": "کوئی کنکشن نہیں۔ اپنا نیٹ ورک دیکھ کر دوبارہ کوشش کریں۔",
      "operationNotAllowed": "ای میل سے سائن ان فی الحال دستیاب نہیں۔",
      "generic": "کچھ غلط ہو گیا۔ براہ کرم دوبارہ کوشش کریں۔"
    },
    "a11y": {
      "stepEmail": "2 میں سے مرحلہ 1۔ اپنا ای میل پتہ درج کریں۔",
      "stepPasswordSignIn": "2 میں سے مرحلہ 2۔ سائن ان کرنے کے لیے اپنا پاس ورڈ درج کریں۔",
      "stepPasswordCreate": "2 میں سے مرحلہ 2۔ اپنے نئے اکاؤنٹ کے لیے پاس ورڈ منتخب کریں۔",
      "stepSent": "ری سیٹ لنک بھیج دیا گیا۔ اپنا ان باکس دیکھیں۔",
      "stepVerify": "اکاؤنٹ بن گیا۔ تصدیقی لنک بھیج دیا گیا۔",
      "resendReady": "اب آپ لنک دوبارہ بھیج سکتے ہیں۔"
    }
  }
}
